import React from 'react'
import styles from "./banner.module.css"

const Banner = ({title, description, imageURL}) => {
  return (
		<div className={styles.banner_container} data-testid="form_banner_section">
			<h2>{title}</h2>
			<p>{description}</p>
			{imageURL && <img src={imageURL} alt={title} />}

		</div>
  );
}

export default Banner
